import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false, testid }) => (
  <span
    data-testid={testid}
    className={`inline-block text-xs font-bold tracking-[0.18em] uppercase mb-5 px-3.5 py-1.5 rounded-full ${
      dark ? "bg-[#74C69D]/15 text-[#74C69D]" : "bg-[#2D6A4F]/10 text-[#2D6A4F]"
    }`}
  >
    {children}
  </span>
);
